<div class="progress-wrap">
  <div
    class="progress"
    [class.thin]="thin"
    [class.indeterminate]="indeterminate"
    role="progressbar"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuenow]="ariaValueNow"
  >
    <div class="progress-bar" [class.is-loading]="showShimmer" [style.width]="barWidth"></div>
  </div>
  @if (label !== null) {
    <span class="progress-label">{{ label }}</span>
  }
</div>
